import * as DialogPrimitive from "@radix-ui/react-dialog";

interface ImagePreviewProps {
  src: string;
  alt: string;
  className?: string;
}

/**
 * Wraps a thumbnail <img> so clicking it opens a full-size lightbox. Uses the Radix
 * primitives directly (rather than the shared ui/dialog.tsx) since that component's
 * padded, max-w-lg card styling is meant for form dialogs, not an edge-to-edge image
 * preview. Clicking outside the enlarged image, or pressing Escape, closes it —
 * both are Radix Dialog's default outside-interaction behavior, not custom code.
 */
const ImagePreview = ({ src, alt, className }: ImagePreviewProps) => {
  return (
    <DialogPrimitive.Root>
      <DialogPrimitive.Trigger asChild>
        <img
          alt={alt}
          title={alt}
          src={src}
          className={className ? `${className} cursor-pointer` : "cursor-pointer"}
        />
      </DialogPrimitive.Trigger>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="image-preview-overlay" />
        <DialogPrimitive.Content
          className="image-preview-content"
          // The trigger thumbnail is already visible in the message list; stealing
          // focus to the enlarged image on open has nothing useful to focus.
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <DialogPrimitive.Title className="sr-only">{alt}</DialogPrimitive.Title>
          <img src={src} alt={alt} className="image-preview-img" />
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export default ImagePreview;
